export const SEARCH_FOCUS = 'header/SEARCH_FOCUS'
export const SEARCH_BLUR = 'header/SEARCH_BLUR'
export const MOUSE_IN = 'header/MOUSE_IN'
export const MOUSE_LEAVE = 'header/MOUSE_LEAVE'
export const THEME_SWITCH = 'header/THEME_SWITCH'
export const SOCKET_INIT = 'header/SOCKET_INIT'
export const MESSAGE_CHANGE= 'header/MESSAGE_CHANGE'
